module.exports = __webpack_public_path__ + "img/vito.52511fca.png";